export * from "./DynamicText";
